<template>
  <div class="about" style="height: 100%">
    <Card class="ew-card" style="height: 95%;">
      <p slot="title">
        <Icon type="md-add"></Icon>添加机器
      </p>
      <div style="height: 100%; overflow-y: scroll;">
        <!-- <Form :model="deviceModel" :label-width="100">
          <Row>
            <Col span="6">
              <FormItem label="機型">
                <Select v-model="deviceModel.deviceType">
                  <Option value="qxz" key="qxz">请选择</Option>
                  <Option v-for="item in deviceTypeList" :value="item.model" :key="item.model">{{ item.model }}</Option>
                </Select>
              </FormItem>
            </Col>
            <Col v-for="item in fieldSort" span="6">
              <FormItem v-if="item !== 'model'" :label="chooseModel.params[item]">
                <Input v-model="deviceModel.params[item]" :placeholder="'请输入 ' + chooseModel.params[item] + '....'"></Input>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <FormItem v-if="fieldSort && fieldSort.length > 0">
              <Button type="primary" @click="sumbitData">提交</Button>
              <Button style="margin-left: 8px" @click="cancel">清空</Button>
            </FormItem>
          </Row>
        </Form> -->
        <Row>
          <Col span="12">
            <Form :model="deviceModel" :label-width="100">
              <FormItem label="機型">
                <Select v-model="deviceModel.deviceType">
                  <Option value="qxz" key="qxz">请选择</Option>
                  <Option v-for="item in deviceTypeList" :value="item.model" :key="item.model">{{ item.model }}</Option>
                </Select>
              </FormItem>
            
              <div v-for="item in fieldSort">
                <FormItem v-if="item !== 'model'" :label="chooseModel.params[item]">
                  <Input v-model="deviceModel.params[item]" :placeholder="'请输入 ' + chooseModel.params[item] + '....'"></Input>
                </FormItem>
              </div>
              <FormItem v-if="fieldSort && fieldSort.length > 0">
                <Button type="primary" @click="sumbitData">提交</Button>
                <Button style="margin-left: 8px" @click="cancel">清空</Button>
              </FormItem>
            </Form>
          </Col>
        </Row>
      </div>
      <Spin size="large" fix v-if="loding"></Spin>
    </Card>
    
  </div>
</template>
<script>
export default {
  data() {
    return {
      deviceModel:{
        deviceType: "qxz",
        params: {}
      },
      chooseModel: {},
      fieldSort: [],
      deviceTypeList: [],
      loding: false,
    };
  },
  watch: {
    'deviceModel.deviceType': {
         handler: function(val, oldVal) {
            //do something
            this.changeDeviceType(val)
         },
     },
    //  deviceModel: {
    //     handler: function(val, oldVal) {
    //       //do something
    //       console.log("99999999999")
    //       this.changeDeviceType(val.deviceType)
    //     },
    //     deep: true
    //  }
  },
  methods: {
    cancel() {
      this.$set(this.deviceModel, "deviceType", "qxz")
    },
    deviceAlreadyExist () {
      this.$Modal.warning({
          title: "该设备已存在",
          content: ""
      });
    },
    successModal() {
      
    },

    sumbitData () {
      this.loding = true
      let sumbitData = JSON.parse(JSON.stringify(this.deviceModel))
      console.log(sumbitData)
      this.$http.postDataWhitToken(this, "/ewlMerchant/merchantDeviceAdd", sumbitData).then(res => {
        this.loding = false
        setTimeout(() => {
          if (res.success) {
            this.$Modal.confirm({
              title: "保存成功，是否清除表单",
              okText: "是",
              cancelText: "否",
              onOk: () => {
                this.cancel()
                
              }
            });
          } else {
            this.deviceAlreadyExist()
          }
        }, 100)
        
      }).catch(err => {
        this.loding = false
        console.error(err)
      })
    },
    changeDeviceType (type) {
      if (type === "qxz") {
        this.deviceModel.deviceTypeID = 0
        this.deviceModel.params = {}
        this.chooseModel = {}
        this.fieldSort.length = []
        
        return
      }
      let thisType = {}
      for (let i = 0; i < this.deviceTypeList.length; i++) {
        thisType = this.deviceTypeList[i] 
        if (thisType.model === type) {
          break
        }
      }
      this.deviceModel.deviceTypeID = thisType.id
      this.chooseModel = thisType
      this.fieldSort = JSON.parse(JSON.stringify(thisType.sort))
    },
    getGeviceTypeList() {
      this.loding = true
      this.$http.postDataWhitToken(this, "/ewlMerchant/merchantDeviceTypeList", {}).then( res => {
        this.loding = false
        this.deviceTypeList = res.deviceTypeList
      }).catch(err => {
        this.loding = false
        console.error(err)
      })
    
    },
  },
  created() {
    this.getGeviceTypeList();
  },
};
</script>
<style>

</style>